import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const SpeeDeeCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
});

export type SpeeDeeCarrierValue = InputSchema.Value<typeof SpeeDeeCarrierInput>;

export type SpeeDeeCarrierForm = InputSchema.Input<typeof SpeeDeeCarrierInput>;

export const SpeeDeeCarrierDefault = (): SpeeDeeCarrierValue => ({
  accountNumber: "",
});

export const CreateSpeeDeeCarrierForm = memo(function CreateSpeeDeeCarrierForm({
  carrierInput,
}: {
  carrierInput: SpeeDeeCarrierForm;
}) {
  return (
    <RedoTextInput
      label="Account number"
      placeholder=""
      setValue={carrierInput.inputs.accountNumber.setValue}
      value={carrierInput.inputs.accountNumber.value}
    />
  );
});
